var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComunicados({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_68_9",
    "data-name": "Componente 68 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "campaign_FILL0_wght300_GRAD0_opsz40",
    d: "M124.006-759.652h-3.27a.887.887,0,0,1-.655-.265.9.9,0,0,1-.264-.658.881.881,0,0,1,.264-.654.894.894,0,0,1,.655-.26h3.27a.887.887,0,0,1,.655.265.9.9,0,0,1,.264.658.881.881,0,0,1-.264.654A.894.894,0,0,1,124.006-759.652Zm-6.026,6.219a.944.944,0,0,1,.605-.365.879.879,0,0,1,.688.183l2.619,1.961a.932.932,0,0,1,.375.605.852.852,0,0,1-.183.678.935.935,0,0,1-.61.375.859.859,0,0,1-.683-.183l-2.629-1.961a.944.944,0,0,1-.365-.605A.879.879,0,0,1,117.979-753.433Zm3.856-16.11-2.565,1.946a.879.879,0,0,1-.688.183.932.932,0,0,1-.605-.375.835.835,0,0,1-.183-.674.946.946,0,0,1,.365-.61l2.574-1.946a.859.859,0,0,1,.683-.183.935.935,0,0,1,.61.375.835.835,0,0,1,.183.674A.935.935,0,0,1,121.835-769.543Zm-20.6,12.74H99.21a2.2,2.2,0,0,1-1.613-.674,2.2,2.2,0,0,1-.674-1.613v-2.961a2.2,2.2,0,0,1,.674-1.613,2.2,2.2,0,0,1,1.613-.674h6.007l4.833-2.881a1.05,1.05,0,0,1,1.142-.009,1.079,1.079,0,0,1,.575.993v11.327a1.079,1.079,0,0,1-.575.993,1.05,1.05,0,0,1-1.142-.009l-4.833-2.881h-2.146v4.789a.887.887,0,0,1-.265.655.9.9,0,0,1-.658.264.881.881,0,0,1-.654-.264.894.894,0,0,1-.261-.655Zm8.7.654v-8.842l-4.215,2.491H99.21a.43.43,0,0,0-.309.141.43.43,0,0,0-.141.309v2.961a.43.43,0,0,0,.141.309.43.43,0,0,0,.309.141h6.505Zm3.861.139v-9.12a5.752,5.752,0,0,1,1.386,1.962,6.327,6.327,0,0,1,.526,2.6,6.327,6.327,0,0,1-.526,2.6A5.752,5.752,0,0,1,113.791-756.011ZM104.346-760.57Z",
    transform: "translate(-94.926 777.213)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComunicados);
export default __webpack_public_path__ + "static/media/comunicados.a5304dc7da731275bd7113340e79c6ea.svg";
export { ForwardRef as ReactComponent };